import { useMutation, useQueryClient } from '@tanstack/react-query';

import { UserKey } from './keys';
import { UserService } from './userService';

export function useResendInvite() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => UserService.resendInvite(id).then((response) => response.data),
    // The resend issues a new link, so the invite expiry shown in the list changes.
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [UserKey.USERS] }),
  });
}
